<template>
    <div class="editor">
        <!-- 编辑器: 标题栏 -->
        <div class="title-bar">{{curItem.cname}}</div>
        <div class="content">
            <el-tabs class="editor-nav" v-model="active" v-if="curItem.tabs.length > 0">
                <el-tab-pane class="nav-tab" :label="item.title" :name="index + ''" v-for="(item, index) in curItem.tabs" :key="index">
                    <template v-for="(style, styleIndex) in curItem.styles">
                        <template v-if="curItem.styles[styleIndex].tab == index">
                            <template v-if="styleIndex == 'selectConfig'">
                                <component v-if="curItem.styles['tabConfig'].type == 0" :is="curItem.styles[styleIndex].name"  :configData="curItem.styles[styleIndex]">
                                </component>
                            </template>
                            <template v-else-if="styleIndex == 'numConfig'">
                                <component v-if="curItem.styles['tabConfig'].type == 0" :is="curItem.styles[styleIndex].name"  :configData="curItem.styles[styleIndex]">
                                </component>
                            </template>
                            <template v-else-if="styleIndex == 'goodsList'">
                                <component v-if="curItem.styles['tabConfig'].type == 1" :is="'cgoods'"  :configData="curItem.styles[styleIndex]">
                                </component>
                            </template>
                            <component v-else :is="curItem.styles[styleIndex].name"  :configData="curItem.styles[styleIndex]">
                            </component>
                        </template>
                    </template>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>

<script>
    import component from './modules'

    export default {
        name: "egoodsList",
        components: {
            ...component,
        },
        props: {
            // 当前选中的元素
            curItem: {
                type: Object,
                default: {}
            },
        },
        data () {
            return {
                active: '0'
            }
        },
        created() {
        }
    }
</script>

<style scoped lang="less">
    .editor {
        .title-bar {
            width: 100%;
            height: 45px;
            line-height: 45px;
            padding-left: 24px;
            color: #000;
            border-radius: 4px;
            border-bottom: 1px solid #eee;
            font-size: 14px;
        }
    }
    /deep/ .slider-box .el-slider__input{
        width: 80px;
    }
    /deep/ .color-box{
        display: flex;
        align-items: center;
        justify-content: flex-end;
        .color-item{
            margin-left: 15px;
            .span{
                margin-left: 5px;
                color: #999;
                font-size: 13px;
                cursor: pointer;
            }
        }
    }
    .editor-nav{
        width: 100%;
        box-sizing: border-box;
        padding: 0 15px;
        /deep/ .nav-tab {
            height: 100%;
            overflow-y: auto;
        }
        /deep/ .el-tabs__nav-scroll {
            padding: 0 30px;
            .el-tabs__item{
                padding-left: 45px;
                padding-right: 45px;
            }
        }
    }
    /deep/ .block-box {
        .block-item{
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 20px;
            .label{
                font-size: 14px;
                color: #999999;
                span{
                    margin-left: 10px;
                    color: #333;
                }
            }
        }
    }
</style>
